import styled from "styled-components";
import { DESKTOP } from "common/constants/breakpoints";

interface PageIndicatorProps {
  active: boolean;
}

export default styled.div<PageIndicatorProps>`
  height: 12px;
  width: 12px;
  border-radius: 50%;
  background-color: ${({ active }) => (active ? "#ffffff" : "#909090")};

  @media screen and (min-width: ${DESKTOP}px) {
    height: 20px;
    width: 20px;
  }
`;
